import ApiService from "./api.service";
import axios from "axios";
import i18n from "../i18n";
import { decrypt, encrypt } from "../shared/utils/crypto-utils";
import { endpoints } from "../utils/utils";

const paymentLinkClient = axios.create();

const PAYMENT_LINK_STATUSES = new Set([
  "redirect_to_payment",
  "already_paid",
  "processing",
  "failed_retry_available",
  "expired",
  "not_payable",
]);

export default class PaymentLinkService extends ApiService {
  static base_url = `${super.base_url}/payment-links`;
  static csrf_url = `${process.env.REACT_APP_BACKEND_URL}${endpoints.csrf}`;

  static decryptPayload(payload) {
    if (payload?.data && payload?.iv) {
      return JSON.parse(decrypt(payload.data, payload.iv));
    }

    return payload;
  }

  static decryptResponse(response) {
    response.data = this.decryptPayload(response?.data);
    return response;
  }

  static statusFromError(error) {
    try {
      const data = this.decryptPayload(error?.response?.data);
      return PAYMENT_LINK_STATUSES.has(data?.status) ? data.status : null;
    } catch {
      return null;
    }
  }

  static async ensureCsrfCookie() {
    await paymentLinkClient.get(this.csrf_url, { withCredentials: true });
  }

  static headers(includeContentType = false) {
    const headers = {
      Accept: "application/json",
      "Accept-Language": i18n.language.startsWith("fr") ? "fr" : "en",
    };

    if (includeContentType) {
      headers["Content-Type"] = "application/json";
    }

    return headers;
  }

  static async resolve(token) {
    const response = await paymentLinkClient.get(`${this.base_url}/${token}/resolve`, {
      headers: this.headers(),
      withCredentials: false,
    });

    return this.decryptResponse(response).data;
  }

  static async retry(token) {
    await this.ensureCsrfCookie();

    const { encrypted, iv } = encrypt(JSON.stringify({}));
    const response = await paymentLinkClient.post(
      `${this.base_url}/${token}/retry`,
      { data: encrypted, iv },
      {
        headers: this.headers(true),
        withCredentials: true,
        withXSRFToken: true,
      }
    );

    return this.decryptResponse(response).data;
  }
}
